<template>
  <section class="cf-flex cf-flex--column cf-flex--gap-16">
    <!-- Modal Image -->
    <svg
      class="cf-image"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_475_853)">
        <path
          class="gift-box"
          :d="giftBoxPath"
          fill="#6AD1E3"
        />
        <path
          class="gift-ribbon"
          opacity="0.4"
          :d="giftRibbonPath"
          fill="#6AD1E3"
        />
      </g>
      <defs>
        <clipPath id="clip0_475_853">
          <rect
            width="120"
            height="120"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>

    <!-- Modal Title -->
    <h2
      data-test-id="claim-points-title-display"
      class="cf-title cf-title--2"
    >
      {{ modalTitle }}
    </h2>

    <template v-if="viewType === 'SUCCESS'">
      <p
        data-test-id="claim-points-success-message-display"
        class="cf-subtitle cf-subtitle--2 dark"
      >
        You've successfully claimed your gifted <span class="bold">{{ giftedPointsString }}</span> Be sure to verify your email.
      </p>

      <button
        type="button"
        data-test-id="claim-points-success-cta-button"
        class="cf-button cf-button--primary cf-button--lg"
        @click="closeModal"
      >
        Continue
      </button>
    </template>

    <template v-else>
      <p class="cf-subtitle cf-subtitle--2 dark">
        <span class="capitalize">{{ offers.giftingPoints.currencyPluralName }}</span> will be added to this account:
      </p>

      <p
        data-test-id="test-id"
        class="cf-subtitle cf-subtitle--2 dark"
      >
        {{ currentUser.email }}
      </p>

      <!-- Claim Points button -->
      <button
        data-test-id="claim-gifted-points-button"
        type="button"
        class="cf-button cf-button--primary cf-button--lg"
        @click="claimToCurrentAccount"
      >
        Claim {{ offers.giftingPoints.currencyPluralName }}
      </button>

      <cf-title-separator />

      <!-- Claim Points To Another Account button -->
      <button
        data-test-id="claim-points-claim-to-another-account-button"
        type="button"
        class="cf-button cf-button--secondary cf-button--lg"
        @click="claimToDifferentAccount"
      >
        Claim on another account
      </button>
    </template>
  </section>
</template>


<script>
  import { mapGetters } from 'vuex';

  import events from '@/services/events';

  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';


  export default {
    name: 'ClaimGiftedPointsModal',

    components: {
      CfTitleSeparator
    },

    props: {
      viewType: {
        type: String,
        default: null
      },

      giftedPoints: {
        type: Number,
        default: 0
      }
    },

    computed: {
      ...mapGetters('session', ['currentUser']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('offers', ['offers']),

      modalTitle() {
        return this.viewType === 'SUCCESS'
          ? `Welcome to ${this.merchant.name}!`
          : `You've been gifted ${this.offers.giftingPoints.currencyPluralName}!`;
      },

      giftedPointsString() {
        return `${this.giftedPoints} ${this.offers.giftingPoints.currencyPluralName}.`;
      },

      giftBoxPath() {
        return 'M44.6484 16.125L52.8047 30H52.5H50.625H35.625C30.4453 30 26.25 25.8047 26.25 20.625C26.25 15.4453 30.4453 11.25 35.625 11.25H36.1406C39.6328 11.25 42.8906 13.1016 44.6484 16.125ZM60 20.0391L54.3516 10.4297C50.5547 3.96094 43.6172 0 36.1406 0H35.625C24.2344 0 15 9.23438 15 20.625C15 32.0156 24.2344 41.25 35.625 41.25H50.625H52.5V60H67.5V41.25H84.375C95.7656 41.25 105 32.0156 105 20.625C105 9.23438 95.7656 0 84.375 0H83.8594C76.3828 0 69.4453 3.96094 65.6484 10.4062L60 20.0391ZM75.3516 16.125C77.1328 13.1016 80.3672 11.25 83.8594 11.25H84.375C89.5547 11.25 93.75 15.4453 93.75 20.625C93.75 25.8047 89.5547 30 84.375 30H67.1953L75.3516 16.125ZM67.5 120V67.5H52.5V120H67.5Z';
      },

      giftRibbonPath() {
        return 'M17.25 30C20.6719 36.6797 27.6094 41.25 35.625 41.25H50.625H52.5V60H7.5C3.35156 60 0 56.6484 0 52.5V37.5C0 33.3516 3.35156 30 7.5 30H17.25ZM112.5 60H67.5V41.25H84.375C92.3906 41.25 99.3281 36.6797 102.75 30H112.5C116.648 30 120 33.3516 120 37.5V52.5C120 56.6484 116.648 60 112.5 60ZM7.5 67.5H52.5V120H18.75C12.5391 120 7.5 114.961 7.5 108.75V67.5ZM67.5 120V67.5H112.5V108.75C112.5 114.961 107.461 120 101.25 120H67.5Z';
      }
    },

    methods: {
      openLoyaltyPopUp() {
        events.emit('loyalty-popup-card:open', {
          autoOpen: true,
          refreshData: true
        });
      },

      async claimToCurrentAccount() {
        await this.$store.dispatch('offers/claimGiftedLoyaltyPoints');

        this.openLoyaltyPopUp();
      },

      closeModal() {
        this.$closeModal('claimGiftedPointsModal');

        this.openLoyaltyPopUp();
      },

      claimToDifferentAccount() {
        this.closeModal();

        this.$store.dispatch('session/signOut');

        this.$openModal('createAccount');
      }
    }
  };
</script>

<style lang="sass">
.gift-box,
.gift-ribbon
  fill: var(--color-brand-primary)
</style>
